import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { ListagemDesenvolvimentoInfantilSuplementacaoVitaminaAModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-desenvolvimentoInfantil'

import { humanizedDateAcompanhamentoCondicaoSaude } from '../utils-acompanhamentoCondicaoSaudeAccordion'

interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSectionProps {
  dataNascimento: LocalDate
  suplementacaoVitaminaA: ListagemDesenvolvimentoInfantilSuplementacaoVitaminaAModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSection({
  dataNascimento,
  suplementacaoVitaminaA,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilSuplementacaoSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='medicineBottleFilled' color={iconColor} />
          <Text fontWeight='bold'>Suplementação de vitamina A</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Última suplementação</Text>
          <Text>{formatDate(suplementacaoVitaminaA.dataUltimaSuplementacao)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Idade na última suplementação</Text>
          <Text>
            {suplementacaoVitaminaA.dataUltimaSuplementacao
              ? humanizedDateAcompanhamentoCondicaoSaude(dataNascimento, suplementacaoVitaminaA.dataUltimaSuplementacao)
              : '-'}
          </Text>
        </VFlow>
      </Cell>
      <Cell size={6} />
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Doses de 6 a 11 meses</Text>
          <Text>{suplementacaoVitaminaA.dosesDe6a11Meses}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Doses de 12 a 23 meses</Text>
          <Text>{suplementacaoVitaminaA.dosesDe12a23Meses}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Doses de 24 a 59 meses</Text>
          <Text>{suplementacaoVitaminaA.dosesDe24a59Meses}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
